Ready(() => {
  document.querySelector('.activate-loader')?.addEventListener('click', (e) => {
    e.preventDefault()
    document.body.classList.add('loading')
  })

  document.querySelector('.sa-page-loader-spinner')?.addEventListener('click', (e) => {
    e.preventDefault()
    document.body.classList.remove('loading')
  })

  document.querySelector('.element-loader-btn')?.addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('.with-element-loader')?.classList.toggle('loading')
  })

  document.querySelector('.sa-element-loader-spinner')?.addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('.with-element-loader')?.classList.remove('loading')
  })
})
